import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {REQUEST_NAME_PATTERN} from '../../constants/request-details.constants';
import {POP_PRODUCTION_REQUEST, SUPPORTED_REQUEST_TYPES} from '../../constants/request-types.constant';

type ArrayItemType<T> = T extends Array<infer R> ? R : any;

export interface RequestNameFormData {
  name: string;
  type: ArrayItemType<typeof SUPPORTED_REQUEST_TYPES>;
}

@Component({
  selector: 'app-request-name-form',
  templateUrl: './request-name-form.component.html',
  styleUrls: ['./request-name-form.component.scss']
})
export class RequestNameFormComponent implements OnInit {
  public maxNameLength = 128;
  public minNameLength = 3;
  public form: FormGroup;
  public dataItem: RequestNameFormData;
  private value = '';
  get placeholder(): string {
    switch(this.dataItem?.type) {
      case POP_PRODUCTION_REQUEST:
        return 'module.requests.label.request-name-placeholder';
    }
    return null;
  }

  get inputHint(): string {
    switch(this.dataItem?.type) {
      case POP_PRODUCTION_REQUEST:
        return 'module.requests.label.request-name-hint';
    }
    return null;
  }

  constructor(
    private dialogRef: MatDialogRef<RequestNameFormComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data: RequestNameFormData,
  ) {
    this.dataItem = { ...data };
  }

  public ngOnInit(): void {
    if (this.dataItem?.name) {
      this.value = this.dataItem?.name;
    }

    this.buildForm();
  }

  private buildForm(): void {
    this.form = this.fb.group({
      name: [this.value, Validators.compose([
        Validators.required,
        Validators.maxLength(this.maxNameLength),
        Validators.minLength(this.minNameLength),
        Validators.pattern(REQUEST_NAME_PATTERN)
      ])]
    });
  }

  public  getErrorMessage(): string {
    if (this.form.invalid) {
      if (this.form.get('name').hasError('required') || this.form.get('name').hasError('notEmpty')) {
        return 'You must enter a value';
      }
      if (this.form.get('name').hasError('maxlength')) {
        return `Maximum length is ${this.maxNameLength}`;
      }

      return 'Invalid value';
    }  return null;
  }

  public addName(): void {
    if (this.form.valid) {
      this.dialogRef.close({name: this.form.controls.name.value, redirect: false});
    } else {
      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.get(key);
        if (control.pristine) {
          control.markAsTouched();
          control.updateValueAndValidity({ onlySelf: true, emitEvent: true });
        }
      });
    }
  }

  public close(): void {
    this.dialogRef.close({name: this.dataItem?.name, redirect: true});
  }

}
